module.exports = __webpack_public_path__ + "static/media/Confidence.f45b6b1a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/Confidence.svg
// module id = 383
// module chunks = 0